<script>
import resources from './resources'

export default {
  name: 'gadget-abstract-specialty',
  mixins: [resources]
}
</script>

<template lang="pug">
  div
    section.gadget-agenda-estatisticas.wrapper.full-width.gadget.m-b-20(v-if="!ishidden")
    section.gadget-resumo-especialidade.white-bg.wrapper.half-width.gadget(v-if="ishidden")
      .gadget-title
        | Resumo por Especialidades
      .actions
        span.icon 
        ul
          li.exclude Remover
          li.half-width Lado a Lado
          li.full-width Tela Inteira
      div
        .col-xs-12.col-sm-6
          label.light-red Mês de Referência
          h3.medium-gray {{ currentMonth }} de {{ scheduleYear }}
        .col-xs-12.col-sm-6
          label.light-red Total de Eventos
          h3.medium-gray {{ total }}
      div(style='margin-top:15px')
        .col-xs-12
          label.light-red Eventos por Especialidade
        .table.col-xs-12
          .row.hidden-xs.hidden-sm
            .col-xs-12.col-sm-7.col-title.active Especialidade
            .col-xs-12.col-sm-5.col-title.text-center Eventos
          .order-by.hidden-md.hidden-lg
            | Ordenar por
            span
              select#ordenar-por(name='Ordenar por')
                option(value='Especialidade') Especialidade
                option(value='Eventos') Eventos
          ul.row
            li(v-for="speciality in statistics", :key="speciality.id")
              .col-xs-12.col-sm-7
                small.grey
                  | Especialidade
                  br
                | {{ speciality.speciality_name }}
              .col-xs-12.col-sm-5.text-center
                small.grey
                  | Atendidos
                  br
                | {{ speciality.events_by_speciality }}
              .clearfix
</template>
<style scoped>
  .m-b-20 {
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/app/professional/dashboard/professional/gadget/components/abstract-speciality/abstract-speciality.vue